'use strict';

function apply(input)
{
    let hasValue,
        field = input.parentNode;
    if (!field.classList.contains('field')) {
        field = null;
    }
    if (input.nodeName === 'SELECT') {
        hasValue = processSelect(input);
    } else {
        hasValue = processInput(input);
        if (field && (input.type === 'radio' || input.type === 'checkbox')) {
            if (input.type === 'radio') {
                let checkedInput = document.querySelector(`input[name="${input.name}"].radio-checked`);
                if (checkedInput) {
                    checkedInput.classList.remove('radio-checked');
                    checkedInput.parentElement.classList.remove('checked');
                }

                input.classList.add('radio-checked');
            }
            field.classList[input.checked ? 'add' : 'remove']('checked');
            field = null;
        }
    }
    if (field) {
        field.classList[hasValue ? 'add' : 'remove']('has-value');
    }

    return hasValue;
}

function check(input)
{
    if (input.nodeName === 'SELECT') {
        return processSelect(input);
    } else {
        return processInput(input);
    }
}

function force(input)
{
    const field = input.parentNode;
    input.classList.add('has-value');
    if (field.classList.contains('field')) {
        field.classList.add('has-value');
    }
}

function remove(input)
{
    const field = input.parentNode;
    input.classList.remove('has-value');
    if (field.classList.contains('field')) {
        field.classList.remove('has-value');
    }
}

function processInput(input)
{
    let hasValue = !!input.value;
    input.classList[hasValue ? 'add' : 'remove']('has-value');
    return hasValue;
}

function processSelect(input)
{
    let hasValue = input.selectedIndex >= 0 && !!input.options[input.selectedIndex].text;
    if (!hasValue && input.classList.contains('enhanced')
                  && (input.classList.contains('attention') || input.dataset.emptyOption)) {
        hasValue = true;
    }
    input.classList[hasValue ? 'add' : 'remove']('has-value');
    return hasValue;
}

export default { apply, check, force, remove }
